import React, { useEffect, useState } from 'react'
import "../scss/manageStatus.scss"
import Select from 'react-select';
import {  REACT_APP_VAM_CONTEXT_LITIGATION, REACT_APP_VAM_ENDPOINT } from '../urls';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import LoadingPage from '../reusableComponents/loader/loadingPage';
import { backPage, editModeOn,getFromDecreaptLocalStorage } from '../utilFunctions';
import { axiosRequest } from '../service';
import { functionalities, manageStatusRemarksMaxLength } from '../consts';
const ManageStatus = (props) => {
    const {claimDetailCookie, getClaimDetails} = props
    const [changeToDropDownLists, setChangeToDropDownLists] = useState([])
    const [selectedChangeToValue, setSelectedChangeToValue] = useState("")
    const [remarks, setRemarks] = useState("")
    const [loadingManageStatus, setLoadingManageStatus] = useState(false)
    const navigate = useNavigate();
    const roleDataCookie = getFromDecreaptLocalStorage("roleData")
    

    useEffect(() => {
        // if(roleDataCookie?.roleName !== "CLAIMS_HANDLER" && roleDataCookie?.roleName !== "Admin"){
        //     toast.error("You are not authorized to view this page.")
        //     backPage()
        //     return
        // }else{
        //     resetFields()
        // }
        getClaimStatus()
        resetFields()
    },[])

    const getClaimStatus=()=>{
        axiosRequest().put(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/manageStatus`, {
            "claimId": claimDetailCookie?.claimNo,
            "validatePayout" : 'true'
            }).then(data => {                
                if (data.data?.message == "true" && (claimDetailCookie?.claimStatus !== "Open" && claimDetailCookie?.claimStatus !== 'Reopen')) setChangeToDropDownLists([{ label: "Reopen", value: "Reopen" }])
                else if ((claimDetailCookie?.claimStatus == "Open" || claimDetailCookie?.claimStatus !== 'Re Open') && (claimDetailCookie?.claimSubstatus == 'Rejection Review' || claimDetailCookie?.claimSubstatus == 'Calculation In-Progress')) setChangeToDropDownLists([{ label: "Repudiate", value: "Repudiate" }, { label: "CWP", value: "CWP" }])
                else setChangeToDropDownLists([])            
            }).catch(error => {
            console.log(error)
        })
    }

    const resetFields = () => {
        setSelectedChangeToValue("")
        setRemarks("")
    } 

    const changeStatus = () => {
        if(claimDetailCookie.assignedTo === "Unassigned" || !claimDetailCookie.assignedTo){
            toast.error("Please Assign Claims Handler.")
            return
        }
        if(!selectedChangeToValue){
            toast.error("Please Select Change to Status.")
            return
        }
        const sanitizedRemarks = remarks.replace(/\n/g, " ");
        if (!sanitizedRemarks) {
            toast.error("Please Enter Remarks.")
            return
        }
        setLoadingManageStatus(true)
        axiosRequest().put(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_LITIGATION}/manageStatus`, {
            "claimId": claimDetailCookie?.claimNo,
            "changeTo": selectedChangeToValue.value,
            "remarks": sanitizedRemarks,
            "submittedBy": roleDataCookie.userID,
            "validatePayout" : 'false'
          }).then(data => {
              setTimeout(() => {
                  getClaimDetails(claimDetailCookie?.claimNo, false)
                  toast.success(data.data.message)
                  resetFields()
                  backPage()
                  setLoadingManageStatus(false)
              }, 3000);
        }).catch(error => {
            console.log(error)
            //toast.error("Something Went Wrong.")
        }).finally(() => {
        })
    }
    return (
        <>
                    <div className="inner-box2Field mt-3">
                    {
                        loadingManageStatus ? <LoadingPage/> : 
                        <div className="detailsHistory">
                            <div className='d-flex align-items-end justify-content-between'>
                                <h3 className="heading_h2History ms-3 mt-4" id="historyHistory">Manage Status</h3>
                            </div>
                            <div className="top-space">
                                <div className="container-fluid align-result-tableCalc">
                                    <div className="row">
                                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                            <div className="query-headingCalc">
                                                Status
                                            </div>
                                            <div>
                                                <input type="text" id="status" className="align4_dataAccess" value={claimDetailCookie?.claimStatus} disabled/>
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                            <div className="query-headingCalc">
                                                Sub-Status
                                            </div>
                                            <div>
                                                <input type="text" id="status" className="align4_dataAccess" value={claimDetailCookie?.claimSubstatus} disabled/>
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                                            <div className="query-headingCalc">
                                                Change to <span className="text-danger">*</span>
                                            </div>
                                            <Select id="exampleInputPassword2" options={changeToDropDownLists}
                                                classNamePrefix="bg-gray" placeholder="Select Change to Status"
                                                value={selectedChangeToValue ? {label: selectedChangeToValue.label} : { label: "Select Change to Status", value: "Select Change to Status" }}
                                                onChange={(data) => {
                                                    setSelectedChangeToValue(data)
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                            <div className="query-headingCalc">
                                                Remarks (Maximum {manageStatusRemarksMaxLength} characters allowed) <span className="text-danger">*</span>
                                            </div>
                                            <div>
                                                <textarea
                                                    className="remarksAccess"
                                                    value={remarks}
                                                    onChange={(e) => {
                                                        setRemarks(e.target.value?.slice(0, manageStatusRemarksMaxLength))}
                                                    }>
                                                </textarea>
                                                <div className="remarks-text-info">
                                                    <p>{remarks.length}/{manageStatusRemarksMaxLength}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    editModeOn(functionalities.MANAGE_STATUS_SUBMISSION) && (
                                        <div className='d-flex' style={{flexDirection: "row", marginLeft:"23px"}}>
                                            <div className = "back_backAccess pointer" onClick={() => backPage()}>Cancel</div>
                                            <div className = "submit-2Access" onClick={() => changeStatus()}>Submit</div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    }
                    </div>
                
        </>
    )
}

export default ManageStatus
